import React from 'react';
import { constructAdditionalElementKey } from 'js/engines/CapabilitiesAssessment/utils';
import QuestionResponse from '../../QuestionResponses/QuestionResponse';

import styles from './PageReview.module.scss';

function AdditionalElementReview({
  page,
  capabilityElement,
  questionMap,
  responses,
}) {
  const { additionalElements } = page;

  if (additionalElements.length === 0) {
    return null;
  }

  return (
    <div className={styles['additional-element-review']}>
      <h3 className={styles['additional-element-review-title']}>
        Additional Questions: {capabilityElement.name}
      </h3>
      {additionalElements.map((element) => {
        const questionKey = constructAdditionalElementKey(
          page,
          capabilityElement,
          element
        );

        const question = questionMap[questionKey];

        return (
          <QuestionResponse
            key={question.id}
            question={question}
            response={responses[question.id]}
          />
        );
      })}
    </div>
  );
}

export default AdditionalElementReview;
